import React from 'react';
import cls from './styles.module.css';
import classnames from 'classnames';

interface Props {
    errorMessage: string;
    classes?: string;
}

export function ModalFieldErrorSpan({ errorMessage, classes }: Props) {
    return <span className={classnames(cls.errorMessage, [classes])}>{errorMessage}</span>;
}
